import { RootstockWithVarsDto } from 'common/api/dto/rootstock.dto';
import { Variety } from 'common/models';
import { Dispatch, SetStateAction, useMemo } from 'react';
import { Column } from 'react-table';
import {
  CenteredHeader,
  CenteredText,
} from '../components/Sub-views/RatesView/Tabs/styles';
import {
  EditBtn,
  Icon,
} from '../components/Sub-views/VarietiesView/Tabs/styles';

export type VarFormValues = {
  rStockId: number;
  rStockCode: string;
  varieties: Variety[];
};

export type RootstocksTableRows = {
  code: string;
  varietyList: string;
  editBtn: VarFormValues;
};

export const useRootstocksTableData: {
  (
    isEditing: VarFormValues | null,
    setIsEditing: Dispatch<SetStateAction<VarFormValues | null>>,
    rows: RootstockWithVarsDto[],
  ): {
    columns: Column<RootstocksTableRows>[];
    data: RootstocksTableRows[];
  };
} = (isEditing, setIsEditing, rows) => {
  const columns: Column<RootstocksTableRows>[] = useMemo(
    () => [
      {
        Header: () => <CenteredHeader>Rootstock</CenteredHeader>,
        accessor: 'code',
        width: '40%',
        Cell: ({ value }) => <CenteredText>{value}</CenteredText>,
      },
      {
        Header: () => <CenteredHeader>Varieties</CenteredHeader>,
        accessor: 'varietyList',
        width: '50%',
        Cell: ({ value }) => <CenteredText>{value}</CenteredText>,
      },
      {
        accessor: 'editBtn',
        width: '10%',
        Cell: ({ value }) => (
          <EditBtn
            type='button'
            onClick={() => setIsEditing(value)}
            disabled={!!isEditing}
          >
            <Icon />
          </EditBtn>
        ),
      },
    ],
    [isEditing, setIsEditing],
  );

  const data: RootstocksTableRows[] = useMemo(
    () =>
      rows.map(({ id, rootstockCode, varieties }) => {
        const sortedVars = varieties.toSorted((a, b) =>
          a.varietyCode.localeCompare(b.varietyCode),
        );

        return {
          code: rootstockCode,
          varietyList: sortedVars.map(v => v.varietyCode).join(', '),
          editBtn: {
            rStockId: id,
            rStockCode: rootstockCode,
            varieties: sortedVars,
          },
        };
      }),
    [rows],
  );

  return {
    columns,
    data,
  };
};
